import "./CalendarApp.css" 

const TileEvent = () => {
  return (
    <div className='event'></div>
  )
}

export default TileEvent